<div class="totally-fullheight-page flex-row-start">
  <div class="flex-row-start samesize-row guestrecieving">
    @for (column of display1(); track column.station.id; let i = $index) {
      <div class="flex-column-start station-column station-column-{{ display1().length + display2().length }} ">
        <div class="header fullwidth station-header">{{ column.station.name }}</div>
        <div class="current-box fullwidth">
          @if (column.currentlySelectedReservation) {
            <div class="appointment-inner-box fullwidth">
              <div class="flex-row-start align-items-center white-background">
                @if (column.currentlySelectedReservation.plateNumber) {
                  <div class="flex-column-centered align-items-center blue-background vehicle-icon-container">
                    <img
                      class="vehicle-icon"
                      src="../../../assets/images/{{
                        getVehicleName(column.currentlySelectedReservation.vehicleType)
                      }}_SELECTED.svg"
                    />
                  </div>
                }
                <div class="flex-row-centered fullwidth" style="position: relative">
                  @if (column.currentlySelectedReservation.plateNumber) {
                    <h3 PlateNumber>
                      {{ column.currentlySelectedReservation.plateNumber }}
                    </h3>
                  }
                  @if (
                    !column.currentlySelectedReservation.plateNumber &&
                    column.currentlySelectedReservation.note &&
                    !column.currentlySelectedReservation.ownReservation
                  ) {
                    <h3>
                      {{ column.currentlySelectedReservation.note }}
                    </h3>
                  }
                  @if (
                    !column.currentlySelectedReservation.plateNumber &&
                    column.currentlySelectedReservation.ownReservation
                  ) {
                    <h3>
                      {{ getCurrentlySelectedReservationService(column.currentlySelectedReservation) | translate }}
                    </h3>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @for (box of getBoxes(i); track $index) {
          <div class="appointment-box fullwidth">
            @if (box.workStationId !== -1) {
              <div class="appointment-inner-box fullwidth" [class.none]="box === null">
                <div class="flex-row-start align-items-center white-background">
                  @if (box.plateNumber) {
                    <div class="flex-column-centered align-items-center blue-background vehicle-icon-container">
                      <img
                        class="vehicle-icon"
                        src="../../../assets/images/{{ getVehicleName(box.vehicleType) }}_SELECTED.svg"
                      />
                    </div>
                  }
                  <div class="flex-row-centered fullwidth" style="position: relative">
                    @if (box.plateNumber) {
                      <h3 PlateNumber>
                        {{ box.plateNumber }}
                        @if (box.reservationState === 1) {
                          <span class="glyphicon glyphicon-eye-open"></span>
                        }
                      </h3>
                    }
                    <!--<h3 *ngIf="!box.plateNumber && box.note">{{box.note}}<span class="glyphicon glyphicon-eye-open" *ngIf="box.reservationState === 1"></span></h3>
                    <h3 *ngIf="!box.plateNumber && !box.vehicleType && !box.note">Saját foglalás<span class="glyphicon glyphicon-eye-open" *ngIf="box.reservationState === 1"></span></h3>-->
                    @if (!box.plateNumber && !box.vehicleType && box.ownReservation) {
                      <h3>
                        {{ getBoxService(box) | translate }}
                        @if (box.reservationState === 1) {
                          <span class="glyphicon glyphicon-eye-open"></span>
                        }
                      </h3>
                    }
                  </div>
                </div>
              </div>
            }
            @if (box === full) {
              <div class="appointment-inner-box fullwidth"></div>
            }
          </div>
        }
      </div>
    }
  </div>
  @if (display2().length > 0) {
    <div class="flex-column-start" style="margin-bottom: 1px; border: 1px solid #999999">
      <div class="flex-row-start fullwidth">
        @for (column of display2(); track column.station.id; let i = $index) {
          <div
            class="flex-column-start station-column station-column-{{
              display1().length + display2().length
            }} queue-column fullwidth noborder"
            style="padding-bottom: 0px"
          >
            <div class="header fullwidth station-header">{{ column.station.name }}</div>
            <div class="current-box fullwidth">
              @if (column.currentlySelectedQueue) {
                <div class="appointment-inner-box fullwidth">
                  <div class="flex-row-start align-items-center white-background">
                    @if (column.currentlySelectedQueue.plateNumber) {
                      <div class="flex-column-centered align-items-center blue-background vehicle-icon-container">
                        <img
                          class="vehicle-icon"
                          src="../../../assets/images/{{
                            getVehicleName(column.currentlySelectedQueue.vehicleType)
                          }}_SELECTED.svg"
                        />
                      </div>
                    }
                    <div class="flex-row-centered fullwidth" style="position: relative">
                      @if (column.currentlySelectedQueue.plateNumber) {
                        <h3 PlateNumber>
                          {{ column.currentlySelectedQueue.plateNumber }}
                          @if (column.currentlySelectedQueue.reservationState === 1) {
                            <span class="glyphicon glyphicon-eye-open"></span>
                          }
                        </h3>
                      }
                      @if (!column.currentlySelectedQueue.plateNumber) {
                        <h3>
                          Saját foglalás
                          @if (column.currentlySelectedQueue.reservationState === 1) {
                            <span class="glyphicon glyphicon-eye-open"></span>
                          }
                        </h3>
                      }
                      <!--<h3 *ngIf="!column.currentlySelectedQueue.plateNumber && !column.currentlySelectedQueue.note">{{column.currentlySelectedQueue.note}}<span class="glyphicon glyphicon-eye-open" *ngIf="column.currentlySelectedQueue.reservationState === 1"></span></h3>-->
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div
        class="flex-column-start station-column noborder nomargin fullwidth"
        style="padding: 0px 2px; width: 100% !important"
      >
        @for (box of getQBoxes(); track $index) {
          <div class="appointment-box fullwidth">
            @if (box.workStationId !== -1) {
              <div class="appointment-inner-box fullwidth" [class.none]="box === null">
                <div class="flex-row-start align-items-center white-background">
                  @if (box.plateNumber) {
                    <div class="flex-column-centered align-items-center blue-background vehicle-icon-container">
                      <img
                        class="vehicle-icon"
                        src="../../../assets/images/{{ getVehicleName(box.vehicleType) }}_SELECTED.svg"
                      />
                    </div>
                  }
                  <div class="flex-row-centered fullwidth" style="position: relative">
                    <div class="flex-column-centered fullwidth">
                      @if (box.plateNumber) {
                        <h3 PlateNumber>{{ box.plateNumber }}</h3>
                      }
                      @if (!box.plateNumber && unloggedUserVehicles[box.vehicleTypeDefinitionId]) {
                        <h3>
                          {{ unloggedUserVehicles[box.vehicleTypeDefinitionId].make }}
                          {{ unloggedUserVehicles[box.vehicleTypeDefinitionId].model }}
                        </h3>
                      }
                      @if (!box.plateNumber && box.vehicleTypeDefinitionId === 0) {
                        <h3 class="fullwidth">
                          {{ 'OwnReservation' | translate }}
                        </h3>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (box === full) {
              <div class="appointment-inner-box fullwidth"></div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
